import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchContactInfo = createAsyncThunk(
  'contact/fetchContactInfo',
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/stay-in-touch`, {
        headers: {
          'accept-language': lang
        }
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to fetch contact info' });
    }
  }
);

export const submitContactUs = createAsyncThunk(
  'contact/submitContactUs',
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${BASE_URL}/contact-us`, formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
); 